import * as React from "react";
import Svg, { Path, Defs, ClipPath, Rect, G } from "react-native-svg";
const MilitaryTechIcon = (props) => (
    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <G clipPath="url(#clip0_7911_1506)">
            <Path d="M17 10.43V2H7V10.43C7 10.78 7.18 11.11 7.49 11.29L11.67 13.8L10.68 16.14L7.27 16.43L9.86 18.67L9.07 22L12 20.23L14.93 22L14.15 18.67L16.74 16.43L13.33 16.14L12.34 13.8L16.52 11.29C16.82 11.11 17 10.79 17 10.43ZM13 12.23L12 12.83L11 12.23V3H13V12.23Z" fill={props?.customColor ?? "#521FAC"} />
        </G>
        <Defs>
            <ClipPath id="clip0_7911_1506">
                <Rect width="24" height="24" fill="white" />
            </ClipPath>
        </Defs>
    </Svg>
);
export default MilitaryTechIcon;
